
import { useNavigate } from "react-router-dom";
import { isJwtExpired, timeToExpire } from '../components/authentication/checkJWT';
import {postData,getDataWithBody, getData} from './auxilarFunctions';
import config from '../config.json';
import data from "@iconify/icons-eva/menu-2-fill";

let initial_state = {
  generalAB: {
      total: 1960,
      total_lastmonth: 70,
      total_lastmonthyear: 150,
      othertotal: 2130,
      othertotal_lastmonth: 140,
      average: 1264,
      avg70:20,
      age_range: '>=70',
      perc_12_month: 27,
      otherperc_12_month: 34,
      perc_12_month_3_days: 15,
      perc_resistance_ab: 56,
     otherperc_resistance_ab: 38
  },
  consultations:{
    all: 7500,
    otherall: 9500,
    ab: 3750,
    otherab: 4750
  },
  prescriptions:{
    all: 1890640,
    otherall: 7402,
    ab: 122960,
    otherab: 5699
  },
  ab: {
    practice_green: 1000,
    practice_green_lastmonth: 60,
    practice_green_lastmonthyear: 130,
    otherpractice_green: 1130,
    otherpractice_green_lastmonth: 120,
    practice_red: 960,
    practice_red_lastmonth:10,
    practice_red_lastmonthyear: 20,
    otherpractice_red: 1000,
    otherpractice_red_lastmonth: 20,
    hospital_green:1250,
    hospital_red: 150,
    total_12_month: 0,
    mostApear: ["Doxycycline"],
    greenPercent: 30,
    redPercent: 70,
    resistace: 47,
    red_resistance_count:  70,
    green_resistance_count:  47,
    types_prescribed: [{
      x: 'Amoxicillin',
      y: 40,
      fillColor: "#26734D", 
      strokeColor: "#26734D"
    }, {
      x: 'Doxycycline',
      y: 4,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Ciprofloxacin',
      y: 10,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Penicillin V',
      y: 5,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Azithromyzin',
      y: 3,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Co-amoxiclav', 
      y: 3,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Cephalexin',
      y: 35,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    } ],
    green_prescribed: [{
      x: 'Amoxicillin',
      y: 40,
      fillColor: "#26734D", 
      strokeColor: "#26734D"
    }, {
      x: 'Doxycycline',
      y: 4,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Ciprofloxacin',
      y: 10,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Penicillin V',
      y: 5,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Azithromyzin',
      y: 3,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Co-amoxiclav', 
      y: 3,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Cephalexin',
      y: 35,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    } ],
    red_prescribed: [{
      x: 'Amoxicillin',
      y: 40,
      fillColor: "#26734D", 
      strokeColor: "#26734D"
    }, {
      x: 'Doxycycline',
      y: 4,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Ciprofloxacin',
      y: 10,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Penicillin V',
      y: 5,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Azithromyzin',
      y: 3,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Co-amoxiclav', 
      y: 3,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Cephalexin',
      y: 35,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    } ],
    types_resistance: [{
      x: 'Amoxicillin',
      y: 60,
      fillColor: "#26734D", 
      strokeColor: "#26734D"
    }, {
      x: 'Trimethoprim',
      y: 5,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Co-Amoxyclav',
      y: 12,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Nitrofurantoin',
      y: 23,
      fillColor: '#26734D',
      strokeColor: '#26734D'
    }, {
      x: 'Cephalosporin',
      y: 5,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Quinolones', 
      y: 38,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    },],
    green_resistance: [
      {
      x: 'Amoxicillin',
      y: 60,
      fillColor: "#26734D", 
      strokeColor: "#26734D"
      }, {
        x: 'Trimethoprim',
        y: 5,
        fillColor: '#26734D',
        strokeColor: '#26734D'
      }, {
        x: 'Nitrofurantoin',
        y: 23,
        fillColor: '#26734D',
        strokeColor: '#26734D'
      },
      {
        x: 'Fosfomycin', 
        y: 38,
        fillColor: '#26734D',
        strokeColor: '#26734D'
      },
    ],
    red_resistance: [ {
      x: 'Co-Amoxyclav',
      y: 12,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    },  {
      x: 'Cephalosporin',
      y: 5,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    }, {
      x: 'Quinolones', 
      y: 38,
      fillColor: '#cc3311',
      strokeColor: '#cc3311'
    },]
    ,
    othertypes_resistance_red: [{
    name: 'Ciprofloxacin',
    data: [93, 100]
    }, 
    {
      name: 'Azithromyzin',
      data: [29, 55]
    }, 
    {
      name: 'Co-amoxiclav', 
      data: [79, 15]
    } ],  
    othertypes_red: [{
    name: 'Ciprofloxacin',
    data: [93, 121]
    }, 
    {
      name: 'Azithromyzin',
      data: [15, 45]
    }, 
    {
      name: 'Co-amoxiclav', 
      data: [59, 35]
    }],  

    othertypes_green: [{
      name: 'Amoxicillin',
      data: [135, 56],
    }, 
    {
      name: 'Doxycycline',
      data: [85, 110],
     }, 
    {
      name: 'Penicillin V',
      data: [23, 0],
    }, 
    {
      name: 'Cephalexin',
      data: [64, 86],
    } ],  

    othertypes_resistance_green: [{
      name: 'Amoxicillin',
      data: [100, 56],
    }, 
    {
      name: 'Doxycycline',
      data: [85, 100],
     }, 
    {
      name: 'Penicillin V',
      data: [23, 0],
    }, 
    {
      name: 'Cephalexin',
      data: [64, 86],
    } ], 
  },
  
  age: {
    green: [6653,8133, 3445, 2176, 2070, 3465, 10300],
    red: [353,133, 500, 700, 200, 650, 980],
    count: [6653,8133, 3445, 2176, 2070, 3465, 10300],
    patients: [353,133, 500, 700, 200, 650, 980],
    othergreen: [5653,9133, 5445, 3176, 1070, 1465, 7300],
    otherred: [153,33, 800, 300, 100, 850, 1080],
    categories: [
      '<1', 
      '1-6',
      '7-17',
      '18-29',
      '30-49',
      '50-69',
      '>=70'
    ]
  },
  
   
  time:{
  green_weekday : [653,833, 564, 455, 760],
  othergreen_weekday : [553,933, 664, 255, 460],
  red_weekday : [353,133, 56, 87, 156],
  otherred_weekday : [453,233, 156, 187, 56],
  green_duration: [36,53,68,13,4],
  othergreen_duration: [60,40,15,15,5],
  red_duration: [10,30,55,15,8],
  otherred_duration: [15, 20, 55, 0, 10],
  previousYear: [],
  greenRed: [],
  },

  year:{
    now: 2024,
    last: 2020,
    data: {}
  },

  gender:{
    male: {
        "count": 289400,
        "patients": 20823
    },
    female: {
      "count": 120824,
      "patients": 8755
    },
  },

  category:{
    gms: {
        "count": 289400,
        "patients": 20823
    },
    private: {
      "count": 120824,
      "patients": 8755
    },
    total: {}
  }


}

// count model
export const antibiotics = {
  state: initial_state, // initial state
  reducers: {

    updateYearData(state,payload) {

      const { now, last } = payload.prescriptionsByyear;
      const zero = [0,0,0,0,0,0,0,0,0,0,0,0]

      return {
          ...state,
          year: {
            now:payload.prescriptionsByyear ? payload.prescriptionsByyear.now ? payload.prescriptionsByyear.now : "" : "",
            last:payload.prescriptionsByyear ? payload.prescriptionsByyear.last ? payload.prescriptionsByyear.last : "" : "",
            data:payload.prescriptionsByyear ? payload.prescriptionsByyear.data ? payload.prescriptionsByyear.data : {} : {}
          }
        }
    },

    updateGeneralAB2(state,payload) {
      let age_range = payload.age_prescribed ? payload.age_prescribed.maxGroup ? payload.age_prescribed.maxGroup.age_range : '' : '';
      if (age_range === '>=70') {
        age_range = '70+';
      }
      return {
          ...state,
          generalAB: {
            total: payload.ab_prescribed ? payload.ab_prescribed.total_j01 ? payload.ab_prescribed.total_j01 : 0 : 0,
            average: payload.ab_prescribed ? payload.ab_prescribed.average ? payload.ab_prescribed.average : 0 : 0,
            avg70: payload.age_prescribed ? payload.age_prescribed.avg70 ? payload.age_prescribed.avg70 : 0 : 0,
            age_range: age_range,
            perc_12_month: payload.percentage_ab ? payload.percentage_ab  : 0,
            perc_12_month_3_days: payload.percentage_ab_longer3 ? payload.percentage_ab_longer3 : 0,
            perc_resistance_ab: 56,
            total_lastmonth: 70,
            total_lastmonthyear: 150,
            othertotal: 2130,
            othertotal_lastmonth: 140,
          }
        }
    },

    updateConsultationsprescriptions(state,payload) {
      return {
          ...state,
          prescriptions:{
            all: payload.ab_prescriptions ? payload.ab_prescriptions[0].total_issues : 0,
            ab: payload.ab_prescriptions ? payload.ab_prescriptions[0].total_j01 : 0,
            otherall: 7402,
            otherab: 5699
          },
        }
    },

    updateABPrescripons(state,payload) {
      const typesPrescribed = [];
      let practiceGreenTotal = 0;
      let practiceRedTotal = 0;
      let otherPracticeGreenTotal = 0;
      let otherPracticeRedTotal = 0;
      const abPrescriptions = payload[0]?.ab_prescriptions.result || [];
      let prescribedGreenData = [];
      let prescribedRedData = [];

      if (abPrescriptions.length >= 1) {
        for (let i = 0; i < abPrescriptions.length && i < 10; i++) {
          if (
            abPrescriptions[i].level_4 &&
            abPrescriptions[i].level_4 !== undefined
          ) {
            let fillColor, strokeColor;
            if (
              ["Penicillin", "Trimethoprim", "Nitrofurantoin"].includes(
                abPrescriptions[i].level_4
              )
            ) {
              fillColor = "#26734D";
              strokeColor = "#26734D";
              prescribedGreenData.push({
                x: abPrescriptions[i].level_4,
                y: parseInt(abPrescriptions[i].total),
                fillColor: fillColor,
                strokeColor: strokeColor,
              });
            } else if (
              [
                "Penicillins with beta-lactam inhibitors",
                "Cephalosporin",
                "Quinolones",
                "Tetracyclines",
                "Macrolides",
              ].includes(abPrescriptions[i].level_4)
            ) {
              fillColor = "#cc3311";
              strokeColor = "#cc3311";
              prescribedRedData.push({
                x: abPrescriptions[i].level_4,
                y: parseInt(abPrescriptions[i].total), 
                fillColor: fillColor,
                strokeColor: strokeColor,
              });
            }

            typesPrescribed.push({
              x: abPrescriptions[i].level_4,
              y: parseInt(abPrescriptions[i].total), 
              fillColor: abPrescriptions[i].color && abPrescriptions[i].color == "Green" ? "#26734D" : "#cc3311",
              strokeColor: abPrescriptions[i].color && abPrescriptions[i].color == "Green" ? "#26734D" : "#cc3311",
            });
          }
        }
      } else {
        prescribedRedData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        prescribedGreenData.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        typesPrescribed.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
      }

      for (const item of payload[0].ab_prescriptions.results) {
          if (item.ab_classification === "Green") {
              practiceGreenTotal += parseInt(item.count);
          }
          if (item.ab_classification === "Red") {
            practiceRedTotal += parseInt(item.count);
          }
      }

      // for (const item of payload[0].ab_prescriptions[0]) {
      //     if (item.ab_classification === "Green") {
      //         otherPracticeGreenTotal += parseInt(item.total);
      //     }
      //     if (item.ab_classification === "Red") {
      //       otherPracticeRedTotal += parseInt(item.total);
      //     }
      // }

      return {
          ...state,
          ab: {

            ...state.ab,
            practice_green: practiceGreenTotal,
            practice_green_lastmonth: 60,
            practice_green_lastmonthyear: 130,
            otherpractice_green: otherPracticeGreenTotal,
            otherpractice_green_lastmonth: 120,
            practice_red: practiceRedTotal,
            practice_red_lastmonth:10,
            practice_red_lastmonthyear: 20,
            otherpractice_red: otherPracticeRedTotal,
            otherpractice_red_lastmonth: 20,
            hospital_green:1250,
            hospital_red: 150,
            total_12_month: payload[1].ab_prescribed,
            all: payload[1].ab_prescribed,
            
            types_prescribed: typesPrescribed,
            red_prescribed: prescribedRedData,
            green_prescribed: prescribedGreenData,
              othertypes_resistance_red: [{
                name: 'Ciprofloxacin',
                data: [93, 100]
                }, 
                {
                  name: 'Azithromyzin',
                  data: [29, 55]
                }, 
                {
                  name: 'Co-amoxiclav', 
                  data: [79, 15]
                } ],  
                othertypes_red: [{
                name: 'Ciprofloxacin',
                data: [93, 121]
                }, 
                {
                  name: 'Azithromyzin',
                  data: [15, 45]
                }, 
                {
                  name: 'Co-amoxiclav', 
                  data: [59, 35]
                }],  
            
                othertypes_green: [{
                  name: 'Amoxicillin',
                  data: [135, 56],
                }, 
                {
                  name: 'Doxycycline',
                  data: [85, 110],
                 }, 
                {
                  name: 'Penicillin V',
                  data: [23, 0],
                }, 
                {
                  name: 'Cephalexin',
                  data: [64, 86],
                } ],  
            
                othertypes_resistance_green: [{
                  name: 'Amoxicillin',
                  data: [100, 56],
                }, 
                {
                  name: 'Doxycycline',
                  data: [85, 100],
                 }, 
                {
                  name: 'Penicillin V',
                  data: [23, 0],
                }, 
                {
                  name: 'Cephalexin',
                  data: [64, 86],
                } ], 
              
          },
        }
    },
    updateGeneralAB(state, payload){

      const zero = [0,0,0,0,0,0,0]

      return {
        ...state,
        age: {
          count: payload.abPrescriptionsByAgeGroup ? ( payload.abPrescriptionsByAgeGroup.count ? payload.abPrescriptionsByAgeGroup.count : zero) : zero,
          patients: payload.abPrescriptionsByAgeGroup ? ( payload.abPrescriptionsByAgeGroup.patients ? payload.abPrescriptionsByAgeGroup.patients : zero) : zero,
          othergreen: [5653,9133, 5445, 3176, 1070, 1465, 7300],
          otherred: [153,33, 800, 300, 100, 850, 1080],
          categories:  [
            '<1', 
            '1-6',
            '7-17',
            '18-29',
            '30-49',
            '50-69',
            '>=70'
          ]
        },
      }
    },
    updateResistance(state, payload) {
      const { count } = payload.resistants || {};
      const resistanceData = payload.resistants.resistanceData || {};
      // Extract antibiotic names and their corresponding counts
      const data = count ? Object.entries(count).map(([name, count]) => ({ name, count })) : [];
      // Sort the data based on antibiotic name
      const topTen = [...data].sort((a, b) => b.count - a.count).slice(0, 10);

      // Prepare data for rendering
      let resistanceData2 = [];
      let resistanceGreenData = [];
      let resistanceRedData = [];
      let greenCount = 0;
      let redCount = 0;

      if (data.length >= 1) {
        resistanceData2 = topTen.map(({ name, count }, key) => {
          let fillColor, strokeColor;
          if (
            name === "Amoxicillin" ||
            name === "Trimethoprim" ||
            name === "Nitrofurantoin" ||
            name === "Fosfomycin"
          ) {
            fillColor = strokeColor = "#26734D";
            resistanceGreenData.push({
              x: name,
              y: count,
              fillColor,
              strokeColor,
            });
            greenCount += resistanceData[name] || 0;
          } else if (
            name === "Co-Amoxyclav" ||
            name === "Cephalosporin" ||
            name === "Quinolones"
          ) {
            fillColor = strokeColor = "#cc3311";
            resistanceRedData.push({
              x: name,
              y: count,
              fillColor,
              strokeColor,
            });
            redCount += resistanceData[name] || 0;
          } else {
            fillColor = strokeColor = key % 2 === 0 ? "#26734D" : "#cc3311";
            if (key % 2 === 0) {
              resistanceGreenData.push({
                x: name,
                y: count,
                fillColor,
                strokeColor,
              });
              greenCount += resistanceData[name] || 0;
            } else {
              resistanceRedData.push({
                x: name,
                y: count,
                fillColor,
                strokeColor,
              });
              redCount += resistanceData[name] || 0;
            }
          }
          return {
            x: name,
            y: count,
            fillColor,
            strokeColor,
          };
        });
      } else {
        resistanceRedData.push({
          x: '',
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        resistanceGreenData.push({
          x: '',
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
        resistanceData2.push({
          x: "",
          y: 0,
          fillColor: "#26734D",
          strokeColor: "#26734D",
        });
      }

      // Calculate percentages using resistanceTotal
      const resistanceTotal = payload.resistants && payload.resistants.denominator
        ? payload.resistants.denominator
        : greenCount + redCount;

      const greenPercent = resistanceTotal ? Math.round((greenCount / resistanceTotal) * 100) : 0;
      const redPercent = resistanceTotal ? Math.round((redCount / resistanceTotal) * 100) : 0;

      return {
          ...state,
          ab: {
            ...state.ab,
            mostApear: payload.resistants ? ( payload.resistants.mostAppeard ? payload.resistants.mostAppeard : '') : '',
            resistace: payload.resistants ? ( payload.resistants.resistance ? payload.resistants.resistance : '0') : '0',
            resistanceTotal: payload.resistants ? ( payload.resistants.resistanceTotal ? payload.resistants.resistanceTotal : '0') : '0',
            denominator: payload.resistants ? ( payload.resistants.denominator ? payload.resistants.denominator : '0') : '0',
            types_resistance: resistanceData2,
            greenPercent: greenPercent,
            redPercent: redPercent,
            red_resistance_count:  greenCount,
            green_resistance_count:  redCount,
            red_resistance:  resistanceRedData,
            green_resistance:  resistanceGreenData,
          },
      }
    },

    updateGender(state, payload){
      return {
        ...state,
        gender: {
          male: payload.patientCountByGender ? ( payload.patientCountByGender.Male ? payload.patientCountByGender.Male : {count: 0, patients: 0}) : {count: 0, patients: 0},
          female: payload.patientCountByGender ? ( payload.patientCountByGender.Female ? payload.patientCountByGender.Female : {count: 0, patients: 0}) : {count: 0, patients: 0},
        },
      }
    },

    updateCategory(state, payload){
      return {
        ...state,
        category: {
          gms: payload.patientCountByType ? ( payload.patientCountByType[1] ? payload.patientCountByType[1] : {count: 0, patients: 0}) : {count: 0, patients: 0},
          private: payload.patientCountByType ? ( payload.patientCountByType[2] ? payload.patientCountByType[2] : {count: 0, patients: 0}) : {count: 0, patients: 0},
          total: payload.patientCountByType ? payload.patientCountByType : {count: 0, patients: 0},
        },
      }
    },
  },
   
  effects: (dispatch) => ({
     
    async getGeneralAB(payload, state) {

      try {
        const promise_1 =await postData(config.url +'/charts/antibiotics', {size:state.filters.size, area:state.filters.area})
        return await this.updateGeneralAB2(promise_1); 
      } catch (error) {
        return error;
      }
    },

    async promice_1(payload, state){

      try {
        const promise_8 =await postData(config.url +'/charts/antibiotics1',{size:state.filters.size, area:state.filters.area})
        
        return await this.updateConsultationsprescriptions(promise_8); 
      } catch (error) {
        return error;
      }
    },

    async promice_2(payload, state){

      try {
        const promise_2 =await postData(config.url +'/charts/antibiotics2',{size:state.filters.size, area:state.filters.area})
        return await Promise.all([promise_2, {ab_prescribed : state.antibiotics.generalAB.total}]).then(data => {
          this.updateABPrescripons(data)
        });
      } catch (error) {
        return error;
      }
    },

    async promice_3(payload, state){

      try {
        const promise_2 =await postData(config.url +'/charts/antibiotics3',{size:state.filters.size, area:state.filters.area})
        return await this.updateResistance(promise_2);
      } catch (error) {
        return error;
      }
    },

    async promice_4(payload, state){

      try {
        const promise_2 =await postData(config.url +'/charts/antibiotics4',{size:state.filters.size, area:state.filters.area})
        return await this.updateYearData(promise_2);
      } catch (error) {
        return error;
      }
    },

    async promice_5(payload, state){

      try {
  
        const promise_5 =await postData(config.url +'/charts/antibiotics5', {size:state.filters.size, area:state.filters.area})
        
        return await this.updateGeneralAB(promise_5);
      } catch (error) {
        return error;
      }
    },
    
    async promice_6(payload, state){

      try {
        const promise_6 =await postData(config.url +'/charts/antibiotics6',{size:state.filters.size, area:state.filters.area})
        
        return await this.updateCategory(promise_6);
      } catch (error) {
        return error;
      }
    },

    async promice_7(payload, state){

      try {
        const promise_7 =await postData(config.url +'/charts/antibiotics7',{size:state.filters.size, area:state.filters.area})

        return await this.updateGender(promise_7);
      } catch (error) {
        return error;
      }
    },
     
    async loadAntibioticData(payload, state) {
      //console.log('loadData pO');
      try {
        // Call all the individual promise functions to reload data with current filters
        await this.getGeneralAB();
        await this.promice_1();
        await this.promice_2();
        await this.promice_3();
        await this.promice_4();
        await this.promice_5();
        await this.promice_6();
        await this.promice_7();
        return;
      } catch (error) {
        console.error('Error loading practice overview data:', error);
        return error;
      }
    },
    
  })
}


// export const antibiotics = {
//     state: initial_state,

//     reducers: {
//       updateGeneralAB(state, payload) {

//         let indexes_ages_filters =  []
//         initial_state.age.categories.forEach(((cat, index)=>{
//           if(payload.all_state.filters.age.includes(cat)) {
//             indexes_ages_filters.push(index);
//           }
//         })) 

//         if(indexes_ages_filters.length == 0) {
//           indexes_ages_filters=[0,1,2,3,4,5,6]
//         }

//         console.log("indexes_ages_filters", indexes_ages_filters)
//         return {
//           ...state,
//           generalAB: {
//             total: Math.round(initial_state.generalAB.total*payload.percentage),
//             average: Math.round(initial_state.generalAB.average*payload.percentage),
//             perc_12_month: Math.round(initial_state.generalAB.perc_12_month*payload.percentage),
//             perc_12_month_3_days: Math.round(initial_state.generalAB.perc_12_month_3_days*payload.percentage),
//             perc_resistance_ab: Math.round(initial_state.generalAB.perc_resistance_ab*payload.percentage),
//           },
//           consultations:{
//             all: Math.round(initial_state.consultations.all*payload.percentage),
//             ab: Math.round(initial_state.consultations.ab*payload.percentage),
//           },
//           prescriptions:{
//             all: Math.round(initial_state.prescriptions.all*payload.percentage),
//             ab: Math.round(initial_state.prescriptions.ab*payload.percentage),
//           },
//           ab: {
//             practice_green: Math.round(initial_state.ab.practice_green*payload.percentage),
//             practice_red: Math.round(initial_state.ab.practice_red*payload.percentage),
//             hospital_green: Math.round(initial_state.ab.hospital_green*payload.percentage),
//             hospital_red: Math.round(initial_state.ab.hospital_red*payload.percentage),
//             types_prescribed: initial_state.ab.types_prescribed.map(m=> {return {...m, y:Math.round(m.y*(payload.percentage))}}),
//             types_resistance: initial_state.ab.types_resistance.map(m=> {return {...m, y:Math.round(m.y*(payload.percentage))}}),
//             total_12_month: Math.round(initial_state.ab.total_12_month*payload.percentage),
//           },
//           age: {
//             green: initial_state.age.green.filter((cat, idx)=>indexes_ages_filters.includes(idx)).map(cat=>Math.round(cat*(payload.percentage))),
//             red: initial_state.age.red.filter((cat, idx)=>indexes_ages_filters.includes(idx)).map(cat=>Math.round(cat*(payload.percentage))),
//             categories: payload.all_state.filters.age.length > 0 ? payload.all_state.filters.age : initial_state.age.categories
//           },
//           time: {
//             green_weekday: initial_state.time.green_weekday.map(m=> Math.round(m*(payload.percentage))),
//             red_weekday: initial_state.time.red_weekday.map(m=> Math.round(m*(payload.percentage))),
//             green_duration: initial_state.time.green_duration.map(m=> Math.round(m*(payload.percentage))),
//             red_duration: initial_state.time.red_duration.map(m=> Math.round(m*(payload.percentage))),
//             green_2021: initial_state.time.green_2021.map(m=> Math.round(m*(payload.percentage))),
//             red_2021: initial_state.time.red_2021.map(m=> Math.round(m*(payload.percentage))),
//             green_2020: initial_state.time.green_2020.map(m=> Math.round(m*(payload.percentage))),
//             red_2020: initial_state.time.red_2020.map(m=> Math.round(m*(payload.percentage))),
            
//           }

//         }
//     }

//     },
//     effects: (dispatch) => ({
//       getGeneralAB(payload, state) {
//         console.log("state", state)
//         let filters = 0;
//         let total_filters = 0;
//         if(state.filters.age.length > 0){
//           filters = filters + state.filters.age.length
//           total_filters = total_filters + 7
//         }
//         if(state.filters.gender.length > 0){
//           filters = filters + state.filters.gender.length
//           total_filters = total_filters + 3
//         }
//         if(state.filters.gms.length > 0){
//           filters = filters + state.filters.gms.length
//           total_filters = total_filters + 2
//         }
//         if (filters > 0 && total_filters > 0) {
//           dispatch.antibiotics.updateGeneralAB({percentage: filters/total_filters, all_state: state });
//         } else {
//           dispatch.antibiotics.updateGeneralAB({percentage: 1 , all_state: state});

//         }
//       }
//     })
// };